import React, { Component } from "react";
import "./index.less";
class Grid extends Component {
  generateItemStyle(index) {
    const { xAxisScales, yAxisScales } = this.props.gridData;
    const gridColumn = (index + 1) % xAxisScales || xAxisScales;
    const gridRow = yAxisScales - Math.floor(index / xAxisScales);
    return {
      gridColumn,
      gridRow,
    };
  }

  generateBlocks() {
    const { xAxisScales, yAxisScales } = this.props.gridData;
    const { gridData } = this.props;
    const arr = Array.from({ lenght: yAxisScales }, () => []);
    for (let i = 0; i < yAxisScales; i++) {
      arr[i] = gridData.gridBlocks.slice(
        i * xAxisScales,
        (i + 1) * xAxisScales
      );
    }
    return arr.reverse();
  }

  render() {
    const { gridData, personInfo } = this.props;
    const { xAxisScales, yAxisScales, colorScheme, anchor } =
      this.props.gridData;
    const blocks = this.generateBlocks();
    return (
      <div className="grid-container">
        <div className={"grid-list"} style={{ display: "flex" }}>
          {blocks.map((block, index) => {
            return (
              <div
                key={index}
                className="grid-list-line"
                style={{
                  height: `calc((100% - ${
                    (yAxisScales - 1) * 5
                  }px) / ${yAxisScales})`,
                }}
              >
                {block.map((item) => (
                  <div
                    key={item.number}
                    className={["grid-talent-item"].join(" ")}
                    style={{
                      background: item.backColor || "#ccc",
                      width: `calc((100% - ${
                        (xAxisScales - 1) * 5
                      }px) / ${xAxisScales})`,
                      border:
                        personInfo.number === item.number
                          ? `1px solid ${colorScheme}`
                          : "none",
                      // ...this.generateItemStyle(index),
                    }}
                  >
                    <div
                      className={
                        anchor.position === "left"
                          ? "grid-talent-item-anchor grid-talent-item-anchor-left"
                          : "grid-talent-item-anchor grid-talent-item-anchor-right"
                      }
                      style={{
                        background: anchor.backColor,
                        color: anchor.color,
                      }}
                    >
                      {item.customNumber || item.number}
                    </div>
                    <div
                      style={{ width: "100%" }}
                      className="item-title-wrapper"
                    >
                      <input
                        disabled="disabled"
                        type="text"
                        className="item-title"
                        value={item.name.text}
                        style={{ color: item.name.fontColor }}
                      />
                    </div>
                  </div>
                ))}
              </div>
            );
          })}
        </div>
      </div>
    );
  }
}

export default Grid;
